import React, { useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Steps, Tooltip, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import useAuthContext from '../../contexts/AuthContext';
import useErrorMessage from '../../utils/ErrorMessage';

const { Step } = Steps;

const MessageHistory = ({ id, downloadFile }) => {
  const { t } = useTranslation();
  const [messages, setMessages] = useState([]);
  const { dispatchAPI } = useAuthContext();
  const { message } = useErrorMessage();

  const getSenderName = (msg) => {
    const name = `${msg.sender.first_name} ${msg.sender.last_name}`;
    if (msg.forAssurmax) {
      if (msg.isResponse)
        if (msg.receiver._id !== msg.sender._id) return `Direction Assurmax`;
    }
    return name;
  };

  const getRecipientName = (msg) => {
    if (msg.recipient)
      return `${msg.recipient.first_name} ${msg.recipient.last_name}`;
    return t('messages.assurmax');
  };

  const getMessages = useCallback(async () => {
    try {
      const { data } = await dispatchAPI('GET', {
        url: `/messages/contract?associated_resource=${id}`
      });
      setMessages(data.sort((a, b) => a - b));
    } catch (e) {
      if (e.response) message(e.response.status);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (id) {
      (async () => {
        await getMessages();
      })();
    }
    // eslint-disable-next-line
  }, [id]);

  return (
    <div>
      {messages.length !== 0 ? (
        <Steps orientation="vertical" current={messages.length + 1}>
          {(messages || [])
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
            .map((item) => (
              <Step
                key={item._id}
                title={`${getSenderName(item)} à ${getRecipientName(item)}`}
                description={
                  <>
                    <div>
                      {`${moment(item.created_at).format(
                        'DD-MM-YYYY'
                      )} à ${moment(item.created_at).format('HH:mm')}`}
                    </div>
                    <div>
                      <div>
                        <span style={{ fontWeight: 'bold' }}>Objet :</span>
                        {` ${item.subject}`}
                      </div>
                      {item.attachments && !!item.attachments.length ? (
                        <>
                          <span style={{ maxWidth: 100 }}>
                            {`${t('messages.form.files')} : `}
                          </span>
                          <span>
                            {item.attachments.map((file) => {
                              return (
                                <Tooltip
                                  placement="topLeft"
                                  title={`${file.metadata?.originalName}`}
                                >
                                  <Button
                                    type="link"
                                    onClick={() => downloadFile(file)}
                                  >
                                    {`${file.metadata?.originalName}`}
                                  </Button>
                                </Tooltip>
                              );
                            })}
                          </span>
                        </>
                      ) : (
                        t('messages.noFiles')
                      )}
                    </div>
                    <p style={{ marginTop: 8 }}>{item.content}</p>
                  </>
                }
              />
            ))}
        </Steps>
      ) : (
        'Aucune données'
      )}
    </div>
  );
};

MessageHistory.propTypes = {
  id: PropTypes.string,
  downloadFile: PropTypes.func.isRequired
};

MessageHistory.defaultProps = {
  id: undefined
};

export default MessageHistory;
